import { warn } from '../core/log';

/** Spec §4.1 — GA4-compatible event names. */
const ECOMMERCE_EVENTS = new Set([
	'view_item',
	'view_item_list',
	'select_item',
	'add_to_cart',
	'remove_from_cart',
	'view_cart',
	'begin_checkout',
	'add_shipping_info',
	'add_payment_info',
	'purchase',
	'refund',
]);

/** Subset that must carry currency + value. */
const MONETARY_EVENTS = new Set(['view_item', 'add_to_cart', 'view_cart', 'begin_checkout', 'purchase', 'refund']);

const REQUIRES_TRANSACTION_ID = new Set(['purchase', 'refund']);

export function isEcommerce(name: string): boolean {
	return ECOMMERCE_EVENTS.has(name);
}

/**
 * Soft-validates GA4-style e-commerce properties: logs warnings via the debug
 * channel when the payload is missing things downstream will need. It does
 * NOT throw — the backend is the source of truth and dropping events for
 * loose shape would surprise integrators.
 */
export function validateEcommerce(name: string, props: Record<string, unknown>): Record<string, unknown> {
	if (MONETARY_EVENTS.has(name) && !props.currency) {
		warn(`emblue.track("${name}"): missing "currency". Use ISO 4217 (e.g. "ARS", "USD").`);
	}
	if (REQUIRES_TRANSACTION_ID.has(name) && !props.transaction_id) {
		warn(`emblue.track("${name}"): missing "transaction_id" — backend dedupe will not work.`);
	}
	const items = props.items as unknown;
	if (items === undefined) {
		if (name !== 'view_item_list' && name !== 'view_cart') {
			warn(`emblue.track("${name}"): missing "items" array.`);
		}
	} else if (!Array.isArray(items)) {
		warn(`emblue.track("${name}"): "items" must be an array.`);
	} else if (items.length === 0) {
		warn(`emblue.track("${name}"): "items" array is empty.`);
	}
	return props;
}
